export default __webpack_public_path__ + "static/media/mur.176ce871.png";